<ion-header class="mobile-header">
  <ion-toolbar brandingBackground="primaryColor">
    <ion-buttons slot="start">
      <ion-button size="small" color="white" fill="clear" (click)="goBack()">
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title (click)="showProtocolOptions()">
      <div class="topDvCaption">
        <div class="title">
          {{activeSupplementProtocol.title? activeSupplementProtocol.title : 'New Supplement Protocol'}}
          <ion-icon name="create-outline"></ion-icon>
        </div>
        <div class="subtitle">
          {{activeSupplementProtocol.startDate | date}}
          <span *ngIf="activeSupplementProtocol.endDate">
            - {{activeSupplementProtocol.endDate | date}}
          </span>
          <ion-icon name="calendar-outline"></ion-icon>
        </div>
      </div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button size="small" color="white" shape="round" (click)="showNotes()" *ngIf="programMode === 'protocol'">
        <ion-icon slot="icon-only" name="list-outline"></ion-icon>
      </ion-button>
      <ion-button size="small" color="white" shape="round" [matMenuTriggerFor]="supplementMobileChangesMenu" *ngIf="(versionHistory?.length > 1 || hasDraft) && programMode === 'protocol'">
        <ion-icon slot="icon-only" name="arrow-undo-outline"></ion-icon>
      </ion-button>
      <ion-button color="success" size="small" fill="solid" shape="round" (click)="publishSupplementProtocol()">
        {{'general.publish' | translate}}
      </ion-button>
    </ion-buttons>
    <mat-menu #supplementMobileChangesMenu="matMenu" yPosition="below">
      <button mat-menu-item (click)="undoRevision()" *ngIf="versionHistory?.length > 1">{{'general.undo' | translate}}</button>
      <button mat-menu-item (click)="revertDraft()" *ngIf="hasDraft">{{'general.revert' | translate}}</button>
    </mat-menu>
  </ion-toolbar>

  <ion-toolbar class="web-header active-plan" *ngIf="programMode === 'protocol' && categoryTabs.length">
    <div class="plan-wrapper">
      <div class="plan-controls">
        <div class="plan-dropdown">
          <div class="plan-heading">{{'general.category' | translate}} {{(activeCategoryIndex || 0) + 1}} / {{categoryTabs.length || 0}}</div>
          <button class="plan-dropdown-btn" type="button" (click)="openCategoryDrawer()">
            <div class="plan-dropdown-title">{{categoryTabs?.[activeCategoryIndex]?.title || ('Category ' + ((activeCategoryIndex || 0) + 1))}}</div>
            <ion-icon [name]="isCategoryPopoverOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
          </button>
        </div>
      </div>
    </div>
  </ion-toolbar>
  <ion-toolbar class="web-header plan-inline-toolbar" [class.is-open]="isCategoryPopoverOpen" *ngIf="programMode === 'protocol' && categoryTabs.length">
    <div class="active-plan-inline-panel" *ngIf="isCategoryPopoverOpen">
      <div class="active-plan-popover" cdkDropList [cdkDropListData]="categoryTabs" (cdkDropListDropped)="drop($event)">
        <div
          class="popover-option"
          cdkDrag
          *ngFor="let category of categoryTabs; let i = index"
          [class.active]="i === activeCategoryIndex"
          (click)="onCategorySelected(i)">
          <span class="drag-handle" cdkDragHandle>
            <ion-icon name="reorder-two-outline"></ion-icon>
          </span>
          <div class="option-content">
            <div class="option-title">{{category?.title || ('Category ' + (i + 1))}}</div>
          </div>
          <div class="option-actions">
            <span *ngIf="i === activeCategoryIndex" class="option-check-circle">
              <ion-icon class="option-check" name="checkmark-outline"></ion-icon>
            </span>
            <button
              type="button"
              class="option-menu-btn"
              mat-icon-button
              stop-propagation
              [matMenuTriggerFor]="supplementCategoryOptionsMenu">
              <ion-icon name="ellipsis-vertical-outline"></ion-icon>
            </button>
            <mat-menu #supplementCategoryOptionsMenu="matMenu" yPosition="below">
              <button mat-menu-item (click)="editCategoryFromDrawer(i)">{{'general.editTitle' | translate}}</button>
              <button mat-menu-item (click)="duplicateCategoryFromDrawer(category, i)">{{'general.duplicateCat' | translate}}</button>
              <button mat-menu-item (click)="saveCategoryToLibraryFromDrawer(category, i)">{{'general.saveToLibrary' | translate}}</button>
              <button mat-menu-item (click)="deleteCategoryFromDrawer(i)">{{'general.deleteCat' | translate}}</button>
            </mat-menu>
          </div>
        </div>
        <div class="ion-text-center ion-padding">
          <ion-button
            size="small"
            color="secondary"
            fill="solid"
            shape="round"
            [matMenuTriggerFor]="addCategoryDrawerMenu">
            <ion-icon slot="start" name="add-outline"></ion-icon>
            <span>{{'general.category' | translate}}</span>
          </ion-button>
          <mat-menu #addCategoryDrawerMenu="matMenu">
            <button mat-menu-item (click)="newCategory()">{{'general.blankCat' | translate}}</button>
            <button mat-menu-item (click)="selectCategory()">{{'general.fromLibrary' | translate}}</button>
          </mat-menu>
        </div>
      </div>
    </div>
  </ion-toolbar>
</ion-header>

<ng-container *ngIf="!comparePaneEmbedded; else embeddedSupplementBuilderContent">
  <ion-content class="ion-padding">
    <ng-container *ngTemplateOutlet="supplementBuilderContent"></ng-container>
  </ion-content>
</ng-container>
<ng-template #embeddedSupplementBuilderContent>
  <div class="ion-padding compare-pane-embedded-content">
    <ng-container *ngTemplateOutlet="supplementBuilderContent"></ng-container>
  </div>
</ng-template>

<ng-template #supplementBuilderContent>
  <div class="content">

    <div class="desktop-sticky-shell ion-hide-lg-down">
      <!-- ⭐ UPDATED WEB HEADER (FULL + CLEAN) -->
      <div class="web-header">
        <div class="left">
          <div class="backBtnTopPanel">
            <div>
              <h2 class="title" (click)="showProtocolOptions()">
                {{activeSupplementProtocol.title || 'New Supplement Protocol'}}
              </h2>

              <!-- ⭐ NEW DATE ROW (ONLY ADDITION) -->
              <div class="date-row">
                <span class="date" (click)="editDate($event, 'startDate')">
                  {{ activeSupplementProtocol.startDate | date:'MMM d, y' }}
                </span>

                <span class="separator">–</span>

                <span class="date"
                      [class.placeholder]="!activeSupplementProtocol.endDate"
                      (click)="editDate($event, 'endDate')">

                  <ng-container *ngIf="activeSupplementProtocol.endDate; else addEndDate">
                    {{ activeSupplementProtocol.endDate | date:'MMM d, y' }}
                  </ng-container>

                  <ng-template #addEndDate>
                    {{'mealPlanBuilder.addEndDate' | translate}}
                  </ng-template>
                </span>

                <ion-icon name="calendar-outline"></ion-icon>
              </div>
              <!-- ⭐ END DATE ROW -->

            </div>

          </div>
        </div>

        <div class="right">
          <ion-button size="small" (click)="undoRevision()" *ngIf="versionHistory?.length > 1 && programMode === 'protocol'">
            <ion-icon name="arrow-undo-outline"></ion-icon> 
            <span>{{'general.undo' | translate}}</span>
          </ion-button>
          <ion-button size="small" (click)="revertDraft()" *ngIf="hasDraft && programMode === 'protocol'">
            <ion-icon name="arrow-undo-outline"></ion-icon> 
            <span>{{'general.revert' | translate}}</span>
          </ion-button>
          <ion-button size="small" (click)="showNotes()" *ngIf="programMode === 'protocol'">
            <ion-icon name="chatbubble-outline"></ion-icon> 
            <span>{{'general.notes' | translate}}</span>
          </ion-button>

          <ion-button size="small" color="success" (click)="publishSupplementProtocol()">
            <ion-icon name="save-outline"></ion-icon> {{'general.publish' | translate}}
          </ion-button>
          <ion-button size="small" class="settings-btn" fill="clear" (click)="goBack()">
            <ion-icon name="close-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
    <!-- ⭐ END UPDATED HEADER -->

    <div class="navDiv m-hide" *ngIf="programMode === 'protocol' && categoryTabs.length">
      <div class="etTabsWrapper">
        <nav class="et-tabs" cdkDropList #headerList="cdkDropList"  cdkDragRootElement=".moveDiv"  cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" appHorizontalScroll>
          <a class="tab" cdkDrag [cdkDragDisabled]="activeCategoryIndex !== i"
             *ngFor="let day of categoryTabs; let i = index;"
             (click)="setActiveCategory(i)"
             [class.active]="activeCategoryIndex === i">
            {{day.title}}
            <span class="action" mat-button [matMenuTriggerFor]="menu" *ngIf="activeCategoryIndex === i">
              <ion-icon name="ellipsis-vertical-outline"></ion-icon>
            </span>
            <mat-menu #menu="matMenu" yPosition="below">
              <button mat-menu-item (click)="editCategoryTitle()">{{'general.editTitle' | translate}}</button>
              <button mat-menu-item (click)="duplicateCategory(day, i)">{{'general.duplicateCat' | translate}}</button>
              <button mat-menu-item (click)="saveCategoryToLibrary(day)">{{'general.saveToLibrary' | translate}}</button>
              <button mat-menu-item (click)="deleteCategory(i)">{{'general.deleteCat' | translate}}</button>
            </mat-menu>
            <span class="moveDiv" *ngIf="activeCategoryIndex === i" cdkDragHandle>
              <ion-icon name="swap-horizontal-outline"></ion-icon>
            </span>
          </a>

          <ion-button size="small" color="secondary" [matMenuTriggerFor]="menu">
            <ion-icon name="add-outline"></ion-icon> {{'general.category' | translate}}
          </ion-button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="newCategory()"> {{'general.blankCat' | translate}}</button>
            <button mat-menu-item (click)="selectCategory()"> {{'general.fromLibrary' | translate}}</button>
          </mat-menu>
        </nav>
      </div>
    </div>

    <div class="switchTabsInner" *ngIf="categoryTabs.length">
              <div class="switchTabsFormDiv">
                <div class="table3td table4td">

                  <!-- Desktop: stacked supplement cards -->
                  <div class="m-hide supplement-builder-wrap"
                       *ngIf="activeCategory.supplements && activeCategory.supplements.length > 0">
                    <table class="supplement-builder-table">
                      <thead>
                        <tr>
                          <th></th>
                          <th>{{'general.supplement' | translate}}</th>
                          <th>{{'general.dose' | translate}}</th>
                          <th>{{'general.timing' | translate}}</th>
                          <th aria-label="{{'general.actions' | translate}}"></th>
                          <th aria-label="{{'general.actions' | translate}}"></th>
                        </tr>
                      </thead>
                      <tbody id="suppDrop" cdkDropList (cdkDropListDropped)="reorderSupplement($event)">
                        <ng-container *ngFor="let supplement of activeCategory.supplements; let i = index">
                          <tr cdkDrag [cdkDragDisabled]="dragDisabled" cdkDragLockAxis="y">
                            <td class="sb-table-idx-cell">
                              <span class="supplement-builder-card__index">{{ i + 1 }}</span>
                            </td>
                            <td>
                              <ion-input class="formControl" type="text" [name]="'sb_title_' + i"
                                         (pointerdown)="disableDrag()" (blur)="enableDrag()"
                                         (ionBlur)="saveSupplementProtocol()" [(ngModel)]="supplement.title">
                              </ion-input>
                            </td>
                            <td>
                              <ion-input class="formControl" type="text" [name]="'sb_dose_' + i"
                                         (pointerdown)="disableDrag()" (blur)="enableDrag()"
                                         (ionBlur)="saveSupplementProtocol()" [(ngModel)]="supplement.dose">
                              </ion-input>
                            </td>
                            <td>
                              <ion-input class="formControl" type="text" [name]="'sb_timing_' + i"
                                         (pointerdown)="disableDrag()" (blur)="enableDrag()"
                                         (ionBlur)="saveSupplementProtocol()" [(ngModel)]="supplement.timing">
                              </ion-input>
                            </td>
                            <td>
                              <div class="sb-pill-bar">
                                <button type="button" class="sb-pill"
                                        [class.sb-pill--has-data]="hasDesktopDetailsData(supplement)"
                                        [class.sb-pill--active]="isDesktopDetailsOpen(i)"
                                        (click)="toggleDesktopDetails(i)">
                                  <span>Info</span>
                                  <ion-icon [name]="isDesktopDetailsOpen(i) ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                                </button>
                              </div>
                            </td>
                            <td class="sb-row-actions-end">
                              <div class="set-actions supplement-builder-card__actions">
                                <button type="button" (pointerdown)="disableDrag()"
                                        (click)="duplicateSupplement(supplement, i)">
                                  <ion-icon size="small" name="copy-outline"></ion-icon>
                                </button>
                                <button type="button" (pointerdown)="disableDrag()"
                                        (click)="removeSupplement(i)">
                                  <ion-icon size="small" name="trash"></ion-icon>
                                </button>
                                <button type="button" cdkDragHandle (pointerdown)="enableDrag()">
                                  <ion-icon size="small" name="swap-vertical-outline"></ion-icon>
                                </button>
                                <button type="button" mat-button (pointerdown)="disableDrag()" [matMenuTriggerFor]="deskRowMenu">
                                  <ion-icon size="small" name="ellipsis-vertical-outline"></ion-icon>
                                </button>
                                <mat-menu #deskRowMenu="matMenu" yPosition="below">
                                  <button mat-menu-item (pointerdown)="disableDrag()"
                                          (click)="saveSupplementToLibrary(supplement)"
                                          [disabled]="!supplement.title">
                                    {{'general.saveToLibrary' | translate}}
                                  </button>
                                </mat-menu>
                              </div>
                            </td>
                          </tr>
                          <tr *ngIf="isDesktopDetailsOpen(i)">
                            <td colspan="6" class="sb-expand-row-cell">
                              <div class="sb-expand-row">
                                <div class="sb-field-pair sb-field-pair--brand-link">
                                  <div class="sb-field">
                                    <label class="sb-label">{{'general.recommendedBrand' | translate}}</label>
                                    <ion-input class="formControl" type="text" [name]="'sb_brand_' + i"
                                               (pointerdown)="disableDrag()" (blur)="enableDrag()"
                                               (ionBlur)="saveSupplementProtocol()" [(ngModel)]="supplement.brand">
                                    </ion-input>
                                  </div>
                                  <div class="sb-field">
                                    <label class="sb-label">{{'general.link' | translate}}</label>
                                    <ion-input class="formControl" type="text" [name]="'sb_url_' + i"
                                               (pointerdown)="disableDrag()" (blur)="enableDrag()"
                                               (ionBlur)="saveSupplementProtocol()" [(ngModel)]="supplement.url">
                                    </ion-input>
                                  </div>
                                </div>
                                <div class="sb-field-pair sb-field-pair--desc-attach">
                                  <div class="sb-field sb-field--attachments">
                                    <label class="sb-label">{{'general.attachments' | translate}}</label>
                                    <div class="sb-attach-strip">
                                      <div class="sb-attach-item" *ngFor="let att of supplementAttachmentsList(supplement); trackBy: trackByAttachmentEntryId">
                                        <ng-container [ngSwitch]="att.type">
                                          <img *ngSwitchCase="'image'" class="sb-attach-thumb" [src]="att.url" alt=""
                                               (click)="showSupplementAttachmentPreview(att.url)" />
                                          <video *ngSwitchCase="'video'" class="sb-attach-video" controls preload="metadata"
                                                 webkit-playsinline="webkit-playsinline">
                                            <source [src]="att.url + '#t=0.1'" />
                                          </video>
                                          <div *ngSwitchCase="'file'" class="sb-attach-file">
                                            <ion-icon name="document-outline"></ion-icon>
                                            <span class="sb-attach-filename">{{ att.fileName }}</span>
                                          </div>
                                          <div *ngSwitchCase="'audio'" class="sb-attach-file">
                                            <ion-icon name="musical-notes-outline"></ion-icon>
                                            <a class="sb-attach-audio-link" (click)="goToAttachmentUrl(att.url)">{{ att.fileName }}</a>
                                          </div>
                                        </ng-container>
                                        <button type="button" class="sb-attach-remove" (pointerdown)="disableDrag()"
                                                (click)="removeProtocolSupplementAttachment(supplement, att.id)">
                                          <ion-icon name="close-circle" size="small"></ion-icon>
                                        </button>
                                      </div>
                                      <button type="button" class="sb-attach-add" (pointerdown)="disableDrag()"
                                              (click)="openProtocolSupplementAttachmentPicker(i)">
                                        <ion-icon name="add-outline"></ion-icon>
                                        <span>{{'general.addAttachment' | translate}}</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="sb-field sb-field--description">
                                    <label class="sb-label">{{'pages.supplement.supplementElement.description' | translate}}</label>
                                    <ion-textarea class="formControl" autoGrow="true" rows="3" [name]="'sb_desc_' + i"
                                                  (pointerdown)="disableDrag()" (blur)="enableDrag()"
                                                  (ionBlur)="saveSupplementProtocol()" [(ngModel)]="supplement.description">
                                    </ion-textarea>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                    <div class="supplement-builder-add-row">
                      <ion-button size="small" color="primary" class="addCommonBtn" [matMenuTriggerFor]="deskAddSuppMenu">
                        <ion-icon name="add-outline"></ion-icon> {{'general.supplement' | translate}}
                      </ion-button>
                      <mat-menu #deskAddSuppMenu="matMenu">
                        <button mat-menu-item (click)="addSupplement()">{{'general.blankSupplement' | translate}}</button>
                        <button mat-menu-item (click)="selectSupplement()">{{'general.fromLibrary' | translate}}</button>
                      </mat-menu>
                    </div>
                  </div>

                  <!-- Mobile: same card layout + reorder -->
                  <div class="d-hide supplement-builder-wrap supplement-builder-wrap--mobile"
                       *ngIf="activeCategory.supplements && activeCategory.supplements.length > 0">
                    <ion-reorder-group (ionItemReorder)="reorderSupplementM($event)" disabled="false">
                      <div class="supplement-builder-card supplement-builder-card--mobile"
                           *ngFor="let supplement of activeCategory.supplements; let i = index">
                        <div class="supplement-builder-card__head">
                          <span class="supplement-builder-card__index">{{ i + 1 }}</span>
                          <div class="set-actions supplement-builder-card__actions">
                            <button type="button" (click)="duplicateSupplement(supplement, i)">
                              <ion-icon size="small" name="copy-outline"></ion-icon>
                            </button>
                            <button type="button" (click)="removeSupplement(i)">
                              <ion-icon size="small" name="trash"></ion-icon>
                            </button>
                            <ion-reorder>
                              <button type="button">
                                <ion-icon size="small" name="swap-vertical-outline"></ion-icon>
                              </button>
                            </ion-reorder>
                            <button type="button" mat-button [matMenuTriggerFor]="mobCardMenu">
                              <ion-icon size="small" name="ellipsis-vertical-outline"></ion-icon>
                            </button>
                            <mat-menu #mobCardMenu="matMenu" yPosition="below">
                              <button mat-menu-item (click)="saveSupplementToLibrary(supplement)" [disabled]="!supplement.title">
                                {{'general.saveToLibrary' | translate}}
                              </button>
                            </mat-menu>
                          </div>
                        </div>
                        <div class="supplement-builder-card__body">
                          <div class="sb-field">
                            <label class="sb-label">{{'general.supplement' | translate}}</label>
                            <ion-input class="formControl" type="text" [name]="'sb_m_title_' + i"
                                       (ionBlur)="saveSupplementProtocol()" [(ngModel)]="supplement.title">
                            </ion-input>
                          </div>
                          <div class="sb-field-pair sb-field-pair--dose-timing">
                            <div class="sb-field">
                              <label class="sb-label">{{'general.dose' | translate}}</label>
                              <ion-input class="formControl" type="text" [name]="'sb_m_dose_' + i"
                                         (ionBlur)="saveSupplementProtocol()" [(ngModel)]="supplement.dose">
                              </ion-input>
                            </div>
                            <div class="sb-field">
                              <label class="sb-label">{{'general.timing' | translate}}</label>
                              <ion-input class="formControl" type="text" [name]="'sb_m_timing_' + i"
                                         (ionBlur)="saveSupplementProtocol()" [(ngModel)]="supplement.timing">
                              </ion-input>
                            </div>
                          </div>
                          <div class="supplement-builder-card__details-toggle-wrap">
                            <button type="button"
                                    class="sb-pill"
                                    [class.sb-pill--has-data]="hasDesktopDetailsData(supplement)"
                                    [class.sb-pill--active]="isMobileDetailsOpen(i)"
                                    (click)="toggleMobileDetails(i)">
                              <span>Info</span>
                              <ion-icon [name]="isMobileDetailsOpen(i) ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                            </button>
                          </div>
                          <div class="supplement-builder-card__details-expand" *ngIf="isMobileDetailsOpen(i)">
                            <div class="sb-field-pair sb-field-pair--brand-link">
                              <div class="sb-field">
                                <label class="sb-label">{{'general.recommendedBrand' | translate}}</label>
                                <ion-input class="formControl" type="text" [name]="'sb_m_brand_' + i"
                                           (ionBlur)="saveSupplementProtocol()" [(ngModel)]="supplement.brand">
                                </ion-input>
                              </div>
                              <div class="sb-field">
                                <label class="sb-label">{{'general.link' | translate}}</label>
                                <ion-input class="formControl" type="text" [name]="'sb_m_url_' + i"
                                           (ionBlur)="saveSupplementProtocol()" [(ngModel)]="supplement.url">
                                </ion-input>
                              </div>
                            </div>
                            <div class="sb-field-pair sb-field-pair--desc-attach">
                              <div class="sb-field sb-field--attachments">
                                <label class="sb-label">{{'general.attachments' | translate}}</label>
                                <div class="sb-attach-strip">
                                  <div class="sb-attach-item" *ngFor="let att of supplementAttachmentsList(supplement); trackBy: trackByAttachmentEntryId">
                                    <ng-container [ngSwitch]="att.type">
                                      <img *ngSwitchCase="'image'" class="sb-attach-thumb" [src]="att.url" alt=""
                                           (click)="showSupplementAttachmentPreview(att.url)" />
                                      <video *ngSwitchCase="'video'" class="sb-attach-video" controls preload="metadata"
                                             webkit-playsinline="webkit-playsinline">
                                        <source [src]="att.url + '#t=0.1'" />
                                      </video>
                                      <div *ngSwitchCase="'file'" class="sb-attach-file">
                                        <ion-icon name="document-outline"></ion-icon>
                                        <span class="sb-attach-filename">{{ att.fileName }}</span>
                                      </div>
                                      <div *ngSwitchCase="'audio'" class="sb-attach-file">
                                        <ion-icon name="musical-notes-outline"></ion-icon>
                                        <a class="sb-attach-audio-link" (click)="goToAttachmentUrl(att.url)">{{ att.fileName }}</a>
                                      </div>
                                    </ng-container>
                                    <button type="button" class="sb-attach-remove"
                                            (click)="removeProtocolSupplementAttachment(supplement, att.id)">
                                      <ion-icon name="close-circle" size="small"></ion-icon>
                                    </button>
                                  </div>
                                  <button type="button" class="sb-attach-add" (click)="openProtocolSupplementAttachmentPicker(i)">
                                    <ion-icon name="add-outline"></ion-icon>
                                    <span>{{'general.addAttachment' | translate}}</span>
                                  </button>
                                </div>
                              </div>
                              <div class="sb-field sb-field--description">
                                <label class="sb-label">{{'pages.supplement.supplementElement.description' | translate}}</label>
                                <ion-textarea class="formControl" autoGrow="true" rows="3" [name]="'sb_m_desc_' + i"
                                              (ionBlur)="saveSupplementProtocol()" [(ngModel)]="supplement.description">
                                </ion-textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ion-reorder-group>
                    <div class="supplement-builder-add-row">
                      <ion-button size="small" color="primary" class="addCommonBtn" [matMenuTriggerFor]="mobAddSuppMenu">
                        <ion-icon name="add-outline"></ion-icon> {{'general.supplement' | translate}}
                      </ion-button>
                      <mat-menu #mobAddSuppMenu="matMenu">
                        <button mat-menu-item (click)="addSupplement()">{{'general.blankSupplement' | translate}}</button>
                        <button mat-menu-item (click)="selectSupplement()">{{'general.fromLibrary' | translate}}</button>
                      </mat-menu>
                    </div>
                  </div>

                  <input type="file" id="protocolBuilderSupplementDesktopFile" hidden multiple
                         (change)="onProtocolSupplementFileInputChange($event)" />
                  <input type="file" id="protocolBuilderSupplementUniversalFile" hidden multiple
                         (change)="onProtocolSupplementFileInputChange($event)" />

                  <div class="category-notes"
                       *ngIf="activeCategory && activeCategory.supplements?.length > 0">
                    <form class="formStyle2">
                      <ion-row>
                        <ion-col>
                          <ion-item class="ion-no-padding">
                            <ion-label position="stacked">{{'general.categoryNotes' | translate}}</ion-label>
                            <ion-textarea class="formControl"
                                          [(ngModel)]="activeCategory.notes"
                                          name="categoryNotes"
                                          autoGrow
                                          (ionBlur)="saveSupplementProtocol()">
                            </ion-textarea>
                          </ion-item>
                        </ion-col>
                      </ion-row>
                    </form>
                  </div>

                </div>
              </div>

              <!-- No Supplements Panel -->
              <div class="noEexcercisePanel"
                *ngIf="!activeCategory.supplements || activeCategory.supplements.length === 0">
                <div class="noEexcercisePanel__img">
                  <img src="../../../../assets/imgs/suplement.png" alt="suplement" />
                </div>
                <h3>{{'supplementProtocols.addSupplement' | translate}}.</h3>
                <div class="actions">
                  <ion-button size="small" color="primary" class="addCommonBtn" (click)="addSupplement()">
                    <ion-icon name="add-outline"></ion-icon>
                    {{'supplementProtocols.newSupplement' | translate}}
                  </ion-button>
                  <ion-button size="small" color="primary" class="addCommonBtn" (click)="selectSupplement()">
                    <ion-icon name="add-outline"></ion-icon>
                    {{'supplementProtocols.fromLibrary' | translate}}
                  </ion-button>
                </div>
              </div>
              <!-- End No Supplements Panel -->

    </div>

    <!-- No Categories Panel -->
    <div class="noEexcercisePanel"
         *ngIf="!categoryTabs.length">
      <div class="noEexcercisePanel__img">
        <img src="../../../../assets/imgs/suplement.png" alt="suplement" />
      </div>
      <h3>{{'supplementProtocols.addSupplementCategory' | translate}}</h3>
      <div class="actions">
        <ion-button size="small" color="primary" class="addCommonBtn" (click)="newCategory()">
          <ion-icon name="add-outline"></ion-icon>
          {{'supplementProtocols.newCategory' | translate}}
        </ion-button>
        <ion-button size="small" color="primary" class="addCommonBtn" (click)="selectCategory()">
          <ion-icon name="add-outline"></ion-icon>
          {{'supplementProtocols.fromLibrary' | translate}}
        </ion-button>
      </div>
    </div>
    <!-- End No Categories Panel -->

  </div>
</ng-template>
